import { render, staticRenderFns } from "./GoodLists.vue?vue&type=template&id=55f6287e&scoped=true&"
import script from "./GoodLists.vue?vue&type=script&lang=js&"
export * from "./GoodLists.vue?vue&type=script&lang=js&"
import style0 from "./GoodLists.vue?vue&type=style&index=0&id=55f6287e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f6287e",
  null
  
)

export default component.exports